import { useTranslation } from 'react-i18next';
import HeaderImage from '../assets/header-image.png';
import CoinCenter from '../assets/coin-center.png';
import CoinLeft from '../assets/coin-left.png';
import CoinRight from '../assets/coin-right.png';
import RightSectionLayout from '../assets/header-layout.png';
import * as S from './styles';
import { useIsMobile } from '@/utils/CalVW';
import { useMissionTotalRewards } from '@/app/hooks/trade/tradeMission';
import BigNumber from 'bignumber.js';
import { useEffect, useState } from 'react';

const RewardHeader = () => {
  const [displayAmount, setDisplayAmount] = useState(0);
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  // 총 보상금액 조회 API 사용: /v1/missions/total-rewards (모든 카테고리)
  const { data } = useMissionTotalRewards();

  const sumAmount = data?.totalRewards ?? 0;

  useEffect(() => {
    if (sumAmount <= 0) return;

    const targetAmount = sumAmount;
    const duration = 1000;
    const steps = 30;
    const increment = targetAmount / steps;
    let current = 0;
    let step = 0;

    const timer = setInterval(() => {
      step++;
      current += increment;
      if (step >= steps) {
        setDisplayAmount(targetAmount);
        clearInterval(timer);
      } else {
        setDisplayAmount(Number(current.toFixed(0)));
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [sumAmount]);

  return (
    <S.Container>
      <S.LeftSection>
        <S.Title>
          {t('totalReward')}{' '}
          <S.TitlePrimary>
            {new BigNumber(displayAmount).toFormat()} USDT
          </S.TitlePrimary>
        </S.Title>
        <S.Description>
          {t('From new users to experienced traders')}
          <br />
          {t('explore foss-x’s exclusive reward benefits now!')}
        </S.Description>

        {/* {!isMobile && <S.JoinButton>{t('Join Now')}</S.JoinButton>} */}
      </S.LeftSection>

      <S.RightSectionWrapper>
        <S.RightSection>
          <S.RightSectionImage src={HeaderImage} alt="header-image" />
          <S.RightSectionRotatedImage src={HeaderImage} alt="header-image" />
          <S.RightSectionLayout
            src={RightSectionLayout}
            alt="right-section-layout"
          />
        </S.RightSection>

        <S.CoinLeft src={CoinLeft} alt="coin-left" />
        <S.CoinCenter src={CoinCenter} alt="coin-center" />
        <S.CoinRight src={CoinRight} alt="coin-right" />
        {isMobile && <S.JoinButtonMobile>{t('Join Now')}</S.JoinButtonMobile>}
      </S.RightSectionWrapper>
    </S.Container>
  );
};

export default RewardHeader;
